export { CreateCompilationDialog } from './CreateCompilationDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/CreateCompilationDialog/index.js